import React from "react";
import { BankIcon, BankIconLarge, CardType } from "@thecb/components";
import { PAYMENT_METHOD_CREDIT_CARD } from "/constants/transaction_history_constants";

export const PaymentMethodIcon = ({ paymentType, cardType, large = false }) => {
  if (paymentType === PAYMENT_METHOD_CREDIT_CARD) {
    return <CardType type={cardType} size={large ? "large" : "small"} />;
  } else {
    return large ? <BankIconLarge /> : <BankIcon />;
  }
};
